import React, { useState, useEffect, useRef } from "react";
import Typography from "./Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";

import { Headphones, BookmarkSimple } from "@phosphor-icons/react";
import Divider from "./Divider";

function TickerInsight({
    item
}){
    const { theme } = useTheme();
    const [selectedAuthor, setSelectedAuthor] = useState(null);

    const authors = [
        { name: "Jason Zweig", hedcut: "https://images.wsj.net/im-735964/AM?width=80&size=1&pixel_ratio=2" },
        { name: "Costas Paris", hedcut: "https://www.wsj.com/media/costas_paris.png?width=80&size=1&pixel_ratio=2" },
        { name: "Telis Demos", hedcut: "https://images.wsj.net/im-321231/AM?width=80&size=1&pixel_ratio=2" },
        { name: " Dan Gallagher", hedcut: "https://images.wsj.net/im-910453/AM?width=80&size=1&pixel_ratio=2" },
    ]

    useEffect(() => {
        setSelectedAuthor(authors[Math.floor(Math.random() * authors.length)]);
    }, []);

    function truncateText(text, maxLength) {
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    }

    const isOpinion = item.type === "opinion";

    const styles = {
        cardContainer:{
            display: "flex",
            flexDirection: "column",
            gap: spacing.xxxs,
            width: "100%",
            height: "fit-content",
            backgroundColor: theme.colors.fillPrimary,
            color: theme.colors.contentPrimary,
            padding: `${spacing.m}px ${spacing.m}px ${spacing.m}px ${spacing.m}px`,
            boxSizing: "border-box",
        },
        card: {
            display: "flex",
            flexDirection: "column",
            gap: spacing.m,
            padding: `${spacing.l}px ${spacing.m}px`,
            border: `1px solid ${theme.colors.fillSecondary}`,
            borderRadius: borderRadius.s,
            backgroundColor: isOpinion ? "#F5F0EB" : theme.colors.fillPrimary, 
        },
        imageContainer:{
            width: "48px",
            height: "48px",
            flexShrink: 0,             
            borderRadius: "50%",       
            overflow: "hidden",        
            backgroundColor: theme.colors.fillSecondary,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        image: {
            width: "48px",
            height: "auto",         
            display: "block",
            borderRadius: "50%",     
        },
        authorContainer: {
            display: "flex",
            gap: spacing.m,
        },
        authorTextContainer: {
            display: "flex",
            flexDirection: "column",
            gap: spacing.s,
        },
        authorText: {
            color: isOpinion ? theme.colors.opinionContent : theme.colors.contentPrimary,
        },
        captionText: {
            color: isOpinion ? theme.colors.opinionContent : theme.colors.contentSecondary,}
    };
    
    


    return (
        <div style={styles.cardContainer}>
            <div style={styles.card}>
                {selectedAuthor && (
                    <div style={styles.authorContainer}>
                        <div style={styles.imageContainer}>
                            <img src={selectedAuthor.hedcut} alt={selectedAuthor.name} style={styles.image} />
                        </div>
                        <div style={styles.authorInfoContainer}>
                            <Typography variant="byline" type="editorial" style={styles.authorText}>
                                By <span style={{ textDecoration: "underline" }}>{selectedAuthor.name}</span>
                            </Typography>
                            <Typography variant="supportingCaption" type="editorial" style={styles.captionText}>
                                10 min ago
                            </Typography>
                        </div>

                    </div>
                   
                )}
                <Typography variant="paragraph" type="editorial" style={{ color: theme.colors.contentPrimary }}>
                    {item.text.sentiment_reasoning}
                </Typography>
            </div>
        </div>
    )
}

export default TickerInsight;